import React from 'react';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { getIniciales } from '../../utils/formatos';
import { Spinner } from '../common/ui';

export default function TablaPacientes({ pacientes, loading, onVerExpediente, onNuevaConsulta, onNuevaFactura }) {
    if (loading) {
        return (
            <div className="p-12 text-center text-slate-500 font-bold bg-white rounded-3xl border border-slate-200">
                <Spinner size="md" className="mx-auto mb-3" />
                Sincronizando censo clínico...
            </div>
        );
    }

    if (!pacientes || pacientes.length === 0) {
        return (
            <div className="p-12 text-center text-slate-500 bg-white rounded-3xl border border-slate-200">
                <h3 className="font-black text-lg text-slate-700">Sin resultados</h3>
                <p className="text-sm font-medium mt-1">No se localizaron expedientes con ese criterio.</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto bg-white rounded-3xl border border-slate-200 shadow-sm">
            <table className="w-full text-left border-collapse text-sm">
                <thead className="bg-slate-50 border-b border-slate-100 text-slate-400 font-black text-[11px] uppercase tracking-widest">
                <tr>
                    <th className="px-6 py-5">Paciente</th>
                    <th className="px-6 py-5">Doc. Identidad</th>
                    <th className="px-6 py-5">Contacto</th>
                    <th className="px-6 py-5 text-right">Operaciones Clínicas</th>
                </tr>
                </thead>
                <tbody className="divide-y divide-slate-100/80">
                {pacientes.map((p) => {
                    // 🔒 Paciente sin relación clínica con este médico: solo datos
                    // administrativos, sin acceso al historial ni a darle cita.
                    const sinAcceso = p.accesoHistorial === false;
                    return (
                    <tr key={p.id || p._id} onClick={() => { if (!sinAcceso) onVerExpediente(p.id || p._id); }}
                        className={`transition-colors group ${sinAcceso ? 'cursor-default' : 'hover:bg-slate-50/80 cursor-pointer'}`}>
                        <td className="px-6 py-4">
                            <div className="flex items-center gap-4">
                                <div className="flex items-center justify-center w-11 h-11 font-black text-clinica-primary bg-clinica-primary/10 border border-clinica-primary/20 rounded-2xl group-hover:scale-105 transition-transform">
                                    {getIniciales(p.nombre, p.apellidos)}
                                </div>
                                <div className="flex flex-col">
                                    <span className="font-bold text-slate-900 group-hover:text-clinica-primary transition-colors">{p.nombre} {p.apellidos}</span>
                                    <span className="text-[11px] font-bold text-slate-400 mt-0.5">ID: {(p.id || p._id)?.slice(-6).toUpperCase()}</span>
                                    {sinAcceso && <span className="inline-flex items-center gap-1 text-[11px] font-bold text-amber-700 mt-0.5"><LockOutlined sx={{ fontSize: 13 }} aria-hidden="true" /> Sin acceso a su historial</span>}
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-4"><span className="px-3 py-1 bg-slate-100 text-slate-600 text-[11px] font-black tracking-wider rounded-lg border border-slate-200/60 shadow-sm">{p.dni || '---'}</span></td>
                        <td className="px-6 py-4 font-semibold text-sm text-slate-600">{p.telefono || '--'}</td>
                        <td className="px-6 py-4 text-right">
                            {sinAcceso ? (
                                <span className="text-xs font-semibold text-slate-400">Para darle cita, pídesela a recepción</span>
                            ) : (
                            <div className="flex items-center justify-end gap-2 opacity-80 group-hover:opacity-100 transition-opacity">
                                <button onClick={(e) => { e.stopPropagation(); onVerExpediente(p.id || p._id); }} className="px-4 py-2 text-xs font-bold text-slate-700 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 shadow-sm transition-all">Ficha</button>
                                <button onClick={(e) => { e.stopPropagation(); onNuevaFactura(p); }} className="px-4 py-2 text-xs font-bold text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-xl hover:bg-emerald-600 hover:text-white shadow-sm transition-all">Cobrar</button>
                                <button onClick={(e) => { e.stopPropagation(); onNuevaConsulta(p.id || p._id); }} className="px-4 py-2 text-xs font-bold text-clinica-primary bg-clinica-primary/10 border border-clinica-primary/20 rounded-xl hover:bg-clinica-primary hover:text-white shadow-sm transition-all">Cita</button>
                            </div>
                            )}
                        </td>
                    </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
}